import * as R from 'ramda';
import React from 'react';
import { withFormik } from 'formik';
import { connect } from 'react-redux';
import { pure, compose } from 'react-recompose';
import { createStructuredSelector } from 'reselect';
// common
import { makeSelectDocumentTemplates } from '../../../common/selectors';
// components
import { FormFooter } from '../../../components/form-footer';
// forms
import { Fieldset2 } from '../../formik';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// ui
import { Box } from '../../../ui';
// feature master-invoice
import { fields, defaultValues, validationSchema } from './settings';
//////////////////////////////////////////////////

const mapStateToProps = (state) => createStructuredSelector({
  documentTemplates: makeSelectDocumentTemplates(state),
});

const enhance = compose(
  connect(mapStateToProps),
  withFormik({
    validationSchema,
    enableReinitialize: true,
    displayName: 'SELECT_PRINT_TEMPLATE_FORM',
    handleSubmit: ({ templateGuid }, { props }) => {
      const { submitAction, documentTemplates, printableSection } = props;

      const format = R.compose(
        R.path([GC.FIELD_FORMAT]),
        R.find(R.propEq(templateGuid, GC.FIELD_GUID)),
        R.pathOr([], [printableSection]),
      )(documentTemplates);

      submitAction({ templateGuid }, format);
    },
    mapPropsToValues: (props) => G.setInitialFormikValues(
      defaultValues,
      props.initialValues,
    ),
  }),
  pure,
);

const getOptions = (documentTemplates, printableSection) => G.addEmptyOptionToDropDown(
  G.mapNameGuidToLabelValue(R.pathOr([], [printableSection], documentTemplates)),
);

const SelectPrintTemplateForm = enhance((props) => {
  const { handleSubmit, printableSection, documentTemplates } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Box>
        <Fieldset2
          {...G.getFormikProps(props)}
          fields={fields}
          fieldsWrapperStyles={{ mt: 10 }}
          documentTemplateOptions={getOptions(documentTemplates, printableSection)}
        />
      </Box>
      <FormFooter />
    </form>
  );
});

export default SelectPrintTemplateForm;
